import type { BoxEntry } from '@deepcloud/api-deep-box'

export function useBoxAvatar() {
  function isInboxCountBiggerThen2Chars(box: BoxEntry) {
    return box.queueCount ? box.queueCount.toString().length > 2 : false
  }

  function getBoxInboxCountText(box: BoxEntry) {
    return box.queueCount
      ? isInboxCountBiggerThen2Chars(box)
        ? '99+'
        : box.queueCount
      : 0
  }

  return {
    isInboxCountBiggerThen2Chars,
    getBoxInboxCountText,
  }
}
